export const isRtlLanguage = (language) => [
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'ha',
    'he',
    'khw',
    'ks',
    'ku',
    'mzn',
    'pnb',
    'ps',
    'sb',
    'ug',
    'ur',
    'yi',
].includes(language);
//# sourceMappingURL=is-rtl-language.js.map